import { Fragment } from "react";
import Seller from "./Seller/Seller";
import ManagerDashboard from "./Manager/ManagerDashboard";
import { useUser } from "../../context";

/**
 * Home routing. Every buyer role now lands on the same operational Panel
 * (`ManagerDashboard`): the counters, the caller's own blocked work, and their
 * team's. Metrics and graphs moved to the dedicated `/analytics` page, so the
 * buyer home no longer embeds them (the old per-role `Buyer` dashboard is gone).
 * Sellers keep their RFQ landing page.
 */
const Home = () => {
  const { isBuy, isSeller } = useUser();

  return (
    <Fragment>
      {isBuy ? <ManagerDashboard /> : null}
      {isSeller ? <Seller /> : null}
    </Fragment>
  );
};

export default Home;
